import { render } from "./DynamicTable.vue?vue&type=template&id=f1b2d924&scoped=true&ts=true"
import script from "./DynamicTable?vue&type=script&lang=ts"
export * from "./DynamicTable?vue&type=script&lang=ts"

import "./DynamicTable.vue?vue&type=style&index=0&id=f1b2d924&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b2d924"]])

export default __exports__